import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

/**
 * Debounce HTTP requests. Prevents some bugs, or unnecessary requests.
 */
@Injectable({ providedIn: 'root' })
export class HttpDelay implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return from(Promise.resolve(req)).pipe(switchMap(req => next.handle(req)));
  }
}
